












































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import TitleCard from './TitleCard.vue'

@Component({
  components: { TitleCard },
})
export default class ConfirmRemovalDialog extends Vue {
  @Prop({ default: false })
  public isShown!: boolean
  @Prop({ required: true })
  public item!: object

  private confirmationChecked: boolean = false
  private privateIsShown: boolean = false

  @Watch('isShown')
  public onIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    this.privateIsShown = value
  }
  @Watch('privateIsShown')
  public onprivateIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    if (!value) {
      this.$emit('deleteItemClosed')
    }
    this.confirmationChecked = false
  }
  get getTitle() {
    return 'Confirm Item Removal'
  }

  public deleteItemConfirmed(item) {
    this.privateIsShown = false
    this.$emit('deleteItemConfirmed', item)
  }
  public deleteItemCancelled(item) {
    this.privateIsShown = false
    this.$emit('deleteItemCancelled')
  }
}
